import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { ButtonWrapper, Wrapper, DatesWrapper } from './styles'
import { defineMessage, FormattedMessage, useIntl } from 'react-intl'
import Link from 'components/shared/Link'
// import Button from 'components/shared/Button'
import Loader from 'components/shared/Loader'
import { getDayNameAndDate } from 'helpers/dates'
import { useListSelfcareOrderPositionsQuery } from 'store/api-slice/hooks'
import { useApp } from 'store/steps'

interface DateOfStayProps {
    editMode?: boolean
    changeOrderData?: () => void
    resetOrder?: () => void
}

const DateOfStay = ({
    editMode = false,
    resetOrder,
    changeOrderData,
}: DateOfStayProps) => {
    const { formatMessage } = useIntl()
    const { language } = useApp()

    const {
        data: positionsData,
        isLoading: arePositionsLoading,
        isError: isPositionsError,
    } = useListSelfcareOrderPositionsQuery({
        _locale: language,
    })

    let label = defineMessage({
        id: 'global.calendar.selected_date_label',
        defaultMessage: 'Data pobytu',
    })

    if (editMode) {
        label = defineMessage({
            id: 'global.calendar.selected_new_date_label',
            defaultMessage: 'Nowa data pobytu',
        })
    }

    const reservationTime = positionsData?.reservationTime || null

    return (
        <Wrapper
            pt={[24, 40]}
            pb={[24, 40]}
            pl={[16, 40]}
            pr={[16, 40]}
            mt={[16, 24]}
        >
            <Box
                gap={16}
                isFullWidth
                direction={['column', 'row']}
                justify="space-between"
            >
                <Box>
                    {/* {editMode && (
                        <Box mb={[16, 24]}>
                            <Text
                                variant="body"
                                color="grayscale_700"
                                mb={[4, 8]}
                            >
                                <FormattedMessage
                                    id="global.calendar.selected_prev_date_label"
                                    defaultMessage="Poprzednia data pobytu"
                                />
                            </Text>
                            <Text variant="bodyStrong" color="grayscale_700">
                                {dateFrom} - {dateTo}
                                <Text
                                    as="span"
                                    variant="bodySmallStrong"
                                    color="grayscale_700"
                                >
                                    (2 dni)
                                </Text>
                            </Text>
                        </Box>
                    )} */}
                    <Text variant="body" color="grayscale_900" mb={[4, 8]}>
                        {formatMessage(label)}
                    </Text>
                    <DatesWrapper gap={4}>
                        {arePositionsLoading &&
                        !reservationTime &&
                        isPositionsError ? (
                            <Loader />
                        ) : (
                            reservationTime?.map((day, index) => {
                                const { from, to } = day
                                return (
                                    <Text
                                        variant="bodyStrong"
                                        color="secondary_500"
                                        key={`${index}+${day.from}`}
                                    >
                                        {!!from &&
                                            getDayNameAndDate({
                                                date: from,
                                                isShortDayName: false,
                                            })}{' '}
                                        {!!to && from !== to && (
                                            <>
                                                {' '}
                                                -{' '}
                                                {getDayNameAndDate({
                                                    date: to,
                                                    isShortDayName: false,
                                                })}
                                            </>
                                        )}
                                    </Text>
                                )
                            })
                        )}
                    </DatesWrapper>
                </Box>
                <ButtonWrapper
                    direction="row"
                    justify="space-between"
                    align="center"
                >
                    <Link
                        variant="gray"
                        onClick={resetOrder}
                        icon={null}
                        data-testid="selfcare-button-cancel-visit"
                    >
                        <FormattedMessage
                            id="selfcare.summary.shortcut_cancel_stay"
                            defaultMessage="Anuluj pobyt"
                        />
                    </Link>

                    {/* TODO: module disabled: GLOBAL DATE CHANGE */}
                    {/* <Button
                        variant={'borderPrimary'}
                        hasArrow={false}
                        onClick={changeOrderData}
                        width="initial"
                    >
                        <FormattedMessage
                            id="selfcare.summary.shortcut_change_dates"
                            defaultMessage="Zmień datę pobytu"
                        />
                    </Button> */}
                </ButtonWrapper>
            </Box>
        </Wrapper>
    )
}

export default DateOfStay
